import React, {FC, MouseEvent} from 'react';

interface LightboxProps {
    imageUrl: string;
    onClose: () => void;
}

const Lightbox: FC<LightboxProps> = ({ imageUrl, onClose }) => {

    function onImageClick(event: MouseEvent) {
        event.stopPropagation();
    }

    return (
        <div onClick={onClose} style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            maxHeight: '100vh',
            maxWidth: '100vw',
            padding: '7vh 7vw',
        }}>
                <img onClick={onImageClick} src={imageUrl} alt="Lightbox" style={{ maxWidth: '100%', maxHeight: '100%', display: 'block', borderRadius: '15px' }} />
                <button onClick={onClose} style={{
                    position: 'absolute',
                    right: '32px',
                    top: '32px',
                    background: 'white',
                    borderRadius: '50%',
                    padding: 5,
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 18,
                    lineHeight: '1',
                    height:30,
                    width:30,
                }}>X</button>
        </div>
    );
};

export default Lightbox;
